<div class="guts-p-full-1 oh">
  <dgx-modal-header
    (dismiss)="activeModal.dismiss()"
    [canCancel]="false"
  ></dgx-modal-header>

  @if (isSelfRegistrationEnabled) {
    <div class="tw-flex tw-justify-center">
      <img
        class="ng-star-inserted tw-h-full tw-max-h-[240px]"
        src="data:image/png;base64,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"
        alt="logo_header_01.png"
      />
    </div>
  }

  <div
    *ngIf="verifyEmail && isSubmitted"
    class="color-ebony-a61 beta center-text guts-p-h-1"
  >
    <p [innerHtml]="headerSubmitted"></p>
  </div>

  <h1
    *ngIf="!isSubmitted"
    class="h2 m-guts-p-h-0 guts-p-h-1 center-text"
    [innerHtml]="header"
  ></h1>
  <div
    *ngIf="verifyEmail && !isMember && !isSubmitted"
    class="center-text guts-m-v-1 guts-p-h-1"
  >
    <form class="crap m-guts-p-h-2 guts-p-h-4">
      <label
        for="workEmail"
        class="ib guts-m-v-1"
        translate="orgInviteFlowModal_VerifyInstructions"
      ></label>
      <div class="field-group">
        <span class="field-group__input">
          <input
            id="workEmail"
            name="workEmail"
            type="email"
            class="zeta"
            [(ngModel)]="userEmail"
            autocomplete="off"
            [placeholder]="
              'orgInviteFlowModal_VerifyEmailFormat'
                | translate: { verifyEmail: verifyEmail }
            "
            data-dgat="orginviteflowModal-6ab"
          />
        </span>
        <span class="field-group__btn">
          <button
            [disabled]="!userEmail"
            [ngClass]="{ is_disabled: !userEmail, 'btn-primary': userEmail }"
            class="btn guts-p-h-2"
            type="submit"
            (click)="submitEmailVerification()"
            translate="Core_Verify"
            data-dgat="orginviteflowModal-ff8"
          ></button>
        </span>
      </div>
    </form>
  </div>
  <div
    *ngIf="isSubmitted"
    class="center-text guts-m-t-half"
    [ngClass]="{ 'tw-mb-5': isSelfRegistrationEnabled }"
  >
    <button
      type="button"
      class="link underline"
      dgxAutofocus
      (click)="isSubmitted = !isSubmitted"
      data-dgat="orginviteflowModal-f68"
    >
      {{ 'orgInviteFlowModal_ResendVerification' | translate }}
    </button>
  </div>
  <div
    *ngIf="!verifyEmail || isMember"
    class="center-text"
    [ngClass]="{ 'tw-mb-5': isSelfRegistrationEnabled }"
  >
    <button
      class="btn btn-primary guts-m-t-1-half guts-p-v-1"
      type="button"
      (click)="this.activeModal.dismiss()"
      translate="orgInviteFlowModal_LetsGetStarted"
      data-dgat="orginviteflowModal-bfe"
    ></button>
  </div>
  <div *ngIf="!isSelfRegistrationEnabled">
    <section class="border-top guts-m-t-2 guts-p-t-2">
      <h2
        class="h2 guts-m-b-1 center-text"
        translate="orgInviteFlowModal_LearnAsTeam"
      ></h2>
      <div class="grid m-guts-p-t-3 guts-p-t-2">
        <div class="grid__col-4">
          <img
            [src]="groupImage"
            [alt]="'orgInviteFlowModal_GroupConversation' | translate"
            class="grid__cell-img"
          />
        </div>
        <div class="grid__col-sm-8">
          <h3
            class="h3 guts-p-b-1"
            translate="orgInviteFlowModal_GroupConversations"
          ></h3>
          <p class="par">
            {{ 'orgInviteFlowModal_SocialGroupFeed' | translate }}
          </p>
        </div>
      </div>
      <div class="grid m-guts-p-t-3 guts-p-t-2">
        <div class="grid__col-4 l_flex-col-2 m-l_flex-col-1">
          <img
            [src]="learningImage"
            [alt]="'orgInviteFlowModal_PersonalLearning' | translate"
            class="grid__cell-img"
          />
        </div>
        <div class="grid__col-sm-8 l_flex-col-1 m-l_flex-col-2">
          <h3
            class="h3 guts-p-b-1"
            translate="orgInviteFlowModal_PersonalizedLearning"
          ></h3>
          <p class="par">
            {{ 'orgInviteFlowModal_DiscoverContentInfo' | translate }}
          </p>
        </div>
      </div>
      <div class="grid m-guts-p-t-3 guts-p-t-2">
        <div class="grid__col-4 m-guts-p-t-3">
          <img
            [src]="recommendationImage"
            [alt]="'orgInviteFlowModal_Recommendations' | translate"
            class="grid__cell-img"
          />
        </div>
        <div class="grid__col-sm-8">
          <h3 class="h3 guts-p-b-1">
            {{ 'orgInviteFlowModal_Recommendations' | translate }}
          </h3>
          <p class="par">
            {{ 'orgInviteFlowModal_RecommendInfo' | translate }}
          </p>
        </div>
      </div>
    </section>
  </div>
</div>
